module.exports = __webpack_public_path__ + "img/2.e4e8d398.png";